import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Card, Typography } from '@mui/material';
import MainCard from '../../../component/cards/MainCard';
import { ReactComponent as IconNutrition } from 'assets/images/icons/By CAC/Icones_cac_05_branco.svg';

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.dark,
    color: '#fff'
}));

const StyledIcon = styled(IconNutrition)(() => ({
    width: '80px',
    height: '80px',
    stroke: '#fff',
    fill: '#fff'
}));

function PlanoNutricaoCard({ planName, planDesc, pacientType, onClick }) {
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
            style={{ cursor: 'pointer' }}
        >
            <CardWrapper
                content={false}
                sx={{
                    '&:hover': {
                        boxShadow: 6,
                        transform: 'scale(1.02)',
                        transition: '0.2s ease-in-out'
                    }
                }}
            >
                <Card
                    elevation={0}
                    sx={{
                        display: 'flex',
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '20px'
                        }}
                        className="CardioId-CardContent-Planos-counter"
                    >
                        <StyledIcon />
                    </Box>

                    <Box sx={{ flex: 1, p: 2 }}>
                        <Typography component="div" variant="h2" color="#fff">
                            {planName}
                        </Typography>
                        <Typography component="div" variant="h4" color="#d6d5d5">
                            {planDesc}
                        </Typography>
                        <Typography component="div" variant="h5" color="#d6d5d5">
                            {pacientType}
                        </Typography>
                    </Box>
                </Card>
            </CardWrapper>
        </div>
    );
}

PlanoNutricaoCard.propTypes = {
    planName: PropTypes.string.isRequired,
    planDesc: PropTypes.string.isRequired,
    pacientType: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default PlanoNutricaoCard;
